import { OrderLoader, OrderLoaderComponentProps } from '@/routes/loaders/OrderLoader.tsx';
import { OrderConfirmationPage } from '@/modules/order/OrderConfirmationPage.tsx';
import { MarketContextProvider, useMarketContext } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { MarketCodeSchema } from '@schuettflix/utils';
import { MessageBox } from '@schuettflix/react-components';
import React from 'react';

function InnerOrderConfirmationRoute({ order }: OrderLoaderComponentProps) {
    const { marketCode: contextMarketCode } = useMarketContext();
    const marketCode = order ? MarketCodeSchema.parse(order.marketCode) : contextMarketCode;

    if (!order) {
        // Necessary because the OrderLoader component does not guarantee that it passes an order object
        throw new Error('Order is required to render order confirmation');
    }

    if (order.status !== 'SUBMITTED') {
        return (
            <MessageBox type="error" title="Error">
                Cannot access OrderConfirmationPage with status: {order.status}
            </MessageBox>
        );
    }

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <OrderConfirmationPage order={order} />
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const OrderConfirmationRoute = OrderLoader(InnerOrderConfirmationRoute);
